<template>
  <!-- Content Wrapper. Contains page content -->
  <div v-if="getGroup" class="content-wrapper">
    <!-- Content Header (Page header) -->

    <!-- /.content-header -->

    <!-- Main content -->
    <template v-if="showChooseGroup">
      <div id="selectGroup">
        <template   v-for="group in header_groups">
   
        <button
        v-if="group.name!=undefined"
          :key="group.name"
          @click="showMenuGroup(group.name)"
        >
          {{ group.label }}
        </button>
        </template>
      </div>
    </template>
    <template v-else>
      <section class="content">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header">
                  <h3 class="card-title">جدول تنظیمات</h3>
                  <div class="card-tools">
                    <div class="input-group input-group-sm insert_box">
              
                    </div>
                  </div>
                </div>
                <template v-if="!status">
            <form id="formSettings">
          <template v-for="item in Items">
            <div class="formSec col-6" :key="item.id" >
              <label :for="item.name + ''">{{item.label+" :"}}</label>
            <b-form-file
              v-if="item.type == 'image'"
              :name="item.name"
              
              accept="image/*"
              drop-placeholder="Drop image here..."
            ></b-form-file>
            <b-form-textarea
              
              :value="item.value"
              :name="item.name"
              v-else
            ></b-form-textarea>
            </div>
          </template>
        </form>

        <div class="d-flex justify-content-center">
          <b-button class="col-6" id="apply_logo" @click="setSettings()" variant="success"
            >ویرایش</b-button
          >
        </div>
                </template>
                <!-- /.card-header -->

                <!-- /.card-body -->
                <!-- <div class="card-footer">
                <b-button variant="warning"
                 @click="showDraggableTable()"
                >
الویت بندی
                </b-button>
              </div> -->
              </div>
              <!-- /.card -->
            </div>
          </div>
        </div>
      </section>
      <Loading :show_loading="status" />

    </template>
    <!-- /.content -->
  </div>
  <Loading v-else :show_loading="true" />
</template>
<script>
import Loading from "@/components/admin/loading.vue";
import mixin from "../../mixins/mixins";
import { BFormInput, BButton,BFormFile,BFormTextarea } from "bootstrap-vue";
export default {
  components: {
    Loading,
    BFormInput,
    BButton,BFormFile,BFormTextarea
  },  metaInfo() {
    return {
      title: " تنظیمات",
    }
  },
  mixins: [mixin],
  data() {
    return {
      helpItem: [],
      columns: [
        {
          label: "عنوان",
          prop: "title",
          width: "400px"
        },
        {
          label: "عنوان",
          prop: "edit",
          width: "400px"
        },
        {
          label: "عنوان",
          prop: "delete",
          width: "400px"
        }
      ],
      fullData: null,
      settings: {},
      group_id: null,
      showChooseGroup: true,
      getGroup: false,
      header_groups: [],
      searchName: null,
      routeKey: "settings",
      showpModal: false,
  
      current_url: "/admin/settings",
      urlParams: null
    };
  },
  created() {
    this.$axios.get("/admin/settings").then((response) => {
      this.getGroup = true;
      
      this.header_groups = response.data.data;
    });
  },
  methods: {
    setSettings(){
      let formSettings=document.getElementById("formSettings")
      let form_data=new FormData(formSettings)
      form_data.append("_method","PUT")
      this.$axios.post("/admin/settings",form_data).then(res=>{
          this.$root.notify(res.data.message, "success");

      })
    },
    deleteItem(id) {
      window
        .swal({
          title: "آیتم حذف شود؟",
          text: "این عمل بازگشت پذیر نیست",
          icon: "warning",

          showCancelButton: true,
          showConfirmButton: true,
          dangerMode: true,
          buttons: ["خیر", "یله"]
        })
        .then((willDelete) => {
          if (willDelete) {
            this.$axios
              .delete(this.current_url + `/${id}`)
              .then((response) => {
                window.swal({
                  icon: "success",
                  showConfirmButton: true,
                  text: response.data.message,
                  button: "OK"
                });
                this.getItemsFromServer(
                  this.current_url,
                  1,
                  false,
                  "",
                  this.routeKey,
                  this.urlParams != undefined ? this.urlParams : ""
                );
              })
              .catch((error) => {
                window.swal({
                  title: "ERROR",
                  showConfirmButton: true,
                  text: error.response.data.message,
                  button: "OK"
                });
              });
          }
        })
        .catch(() => {});
    },
   
    async Submit(form_data) {
      form_data.append("_method", this.mode == "edit" ? "put" : "post");

      this.disabled = true;
      await this.$axios
        .post(
          this.current_url +
            (this.mode == "edit" ? `/${this.edit_item.id}` : ""),
          form_data
        )
        .then((response) => {
          this.disabled = false;
          this.getItemsFromServer(
            this.current_url,
            1,
            false,
            "",
            this.routeKey,
            this.urlParams != undefined ? this.urlParams : ""
          );
          this.mode = "create";
          this.$root.notify(response.data.message, "success");
          this.showpModal = false;
          this.edit_item = null;
        })
        .catch((error) => {
          this.disabled = false;
          this.$root.notify(error);
        });
    },
    
    showMenuGroup(id) {
      this.urlParams = `/${id}`;
      this.group_id = id;
      this.getItemsFromServer(
        this.current_url,
        this.$route.query.page != undefined ? this.$route.query.page : "1",
        true,
        '',
        this.routeKey,
        this.urlParams
      );

      this.showChooseGroup = false;
    },
    showPostModal() {
      this.mode = "create";

      // this.$bvModal.show("postModal");
      this.showpModal = true;
    }
  },

};
</script>
<style scoped>
#selectGroup button {
  padding: 30px;
  margin: 50px 50px;
  border-radius: 14px;
  font-size: 32px;
  cursor: pointer;
}
#selectGroup {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 20px;
}
.tableRow {
  padding: 10px;
  border-right: 3px solid grey;
}
.sTABLE {
  display: flex;
  flex-direction: column-reverse;
  margin:10px 0;
}
.tableButtons {
  margin-right: 5px;
}
.itemTitle {
  font-size: 20px;
  font-weight: bold;
}
#formSettings{
   
  display: flex;
  flex-wrap: wrap;
  margin: 10px 0;
}
</style>
